import { jsxs as t, Fragment as l, jsx as e } from "react/jsx-runtime";
import { TextSkeleton as n } from "../../../components/TextSkeleton/index.js";
import { DealSaveButtonMobileContainer as m } from "../DealSaveButton/style.js";
import { DealActionBarContainer as c, DealActionBarItem as o, SkeletonCommentLink as d, DealActionBarCaption as i, SkeletonVoteButton as h, SkeletonSaveButton as u, SkeletonLink as k, SkeletonSaveButtonMobile as p } from "./style.js";
function D({
  className: a,
  hasSaveButton: r
}) {
  return /* @__PURE__ */ t(l, { children: [
    /* @__PURE__ */ t(c, { className: a, children: [
      /* @__PURE__ */ t(o, { children: [
        /* @__PURE__ */ e(d, { animate: !0 }),
        /* @__PURE__ */ e(i, { children: /* @__PURE__ */ e(n, { width: "70px", animate: !0 }) })
      ] }),
      /* @__PURE__ */ t(o, { children: [
        /* @__PURE__ */ e(h, { animate: !0 }),
        /* @__PURE__ */ e(i, { children: /* @__PURE__ */ e(n, { width: "102px", animate: !0 }) })
      ] }),
      r && /* @__PURE__ */ t(u, { children: [
        /* @__PURE__ */ e(k, { animate: !0 }),
        /* @__PURE__ */ e(i, { children: /* @__PURE__ */ e(n, { width: "60px", animate: !0 }) })
      ] })
    ] }),
    r && /* @__PURE__ */ e(m, { children: /* @__PURE__ */ e(p, { width: "100%", animate: !0 }) })
  ] });
}
export {
  D as DealActionBarSkeleton
};
